import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana28Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">

    <rect width="1221" height="921" fill="url(#pattern0_1468_40227)"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("7"))}
    d="M648.097 640.195L652.5 587.352L562.228 563.132L551.219 604.966L618.228 655.223C620.498 656.925 623.119 658.204 625.951 658.376C640.496 659.259 646.754 648.252 648.097 640.195Z" 
    fill={getFillByLot(7, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("6"))}
    d="M661.304 519.096L652.496 587.351L562.224 563.131L579.838 499.28L661.304 519.096Z" 
    fill={getFillByLot(6, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("5"))}
    d="M674.517 444.234L661.306 519.095L582.042 499.279L601.858 424.418L674.517 444.234Z" 
    fill={getFillByLot(5, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("8"))}
    d="M493.97 558.727L551.216 604.964L579.839 499.279L511.584 483.866L493.97 558.727Z" 
    fill={getFillByLot(8, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("4"))}
    d="M526.993 406.803L511.58 483.865L582.037 499.278L601.853 424.417L526.993 406.803Z" 
    fill={getFillByLot(4, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}
    d="M441.129 386.989L526.999 406.805L513.788 470.657L425.717 448.639L441.129 386.989Z" 
    fill={getFillByLot(3, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("9"))}
    d="M412.505 494.877L493.971 558.729L513.787 470.658L425.716 448.64L412.505 494.877Z" 
    fill={getFillByLot(9, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}
    d="M357.455 450.841L412.499 494.877L441.123 386.989L379.473 373.779L357.455 450.841Z" 
    fill={getFillByLot(2, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    d="M282.242 388.164L357.455 450.841L379.473 373.779L284.231 352.133C283.161 351.89 282.031 351.924 281.024 352.36C269.388 357.392 271.807 370.865 275.819 380.083C277.211 383.282 279.562 385.93 282.242 388.164Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <defs>
  <pattern id="pattern0_1468_40227" patternContentUnits="objectBoundingBox" width="1" height="1">
  <use href="#image0_1468_40227" transform="matrix(0.0030201 0 0 0.00400385 -5.04128 -1.32826)"/>
  </pattern>
  <image id="image0_1468_40227" width="4096" height="2304" href="/mz2.png"/>
    </defs>
</svg>

  );
};